/* =========================================================
   Ankit START - DFW Cart Bus
   ========================================================= */

(function(){

  /* -----------------------------
     Sync Cart
  ----------------------------- */

  window.dfwSyncCart = function(){

    fetch("/cart.js",{credentials:"same-origin"})
      .then(r=>r.json())
      .then(cart=>{

        document.dispatchEvent(
          new CustomEvent("dfw:cart-updated",{detail:cart})
        );

      });

  };


  /* -----------------------------
     Detect FETCH cart changes
  ----------------------------- */

  const originalFetch = window.fetch;

  window.fetch = function(){

    const args = arguments;

    return originalFetch.apply(this,args).then(function(res){

      try{

        const url = args[0];

        if(typeof url === "string"){

          if(
            url.includes("/cart/add") ||
            url.includes("/cart/change") ||
            url.includes("/cart/update") ||
            url.includes("/cart/clear")
          ){

            window.dfwSyncCart();

          }

        }

      }catch(e){}

      return res;

    });

  };


  /* -----------------------------
     Detect XHR cart changes
  ----------------------------- */

  const originalOpen = XMLHttpRequest.prototype.open;

  XMLHttpRequest.prototype.open = function(method,url){

    this.addEventListener("load",function(){

      try{

        if(
          url.includes("/cart/add") ||
          url.includes("/cart/change") ||
          url.includes("/cart/update") ||
          url.includes("/cart/clear")
        ){

          window.dfwSyncCart();

        }

      }catch(e){}

    });

    return originalOpen.apply(this,arguments);

  };

})();

/* =========================================================
   Ankit END - DFW Cart Bus
   ========================================================= */
